const translations = {
  en: {
    // TopFold
    aboutUs: 'About Us',
    services: 'Services',
    projects: 'Projects',
    contact: 'Contact',
    getStarted: 'Get Started',
    buildingTheFuture: 'Building The Future',
    companyDescription: 'Advanced Elements General Contracting Company delivers exceptional professionalism, precision, and efficient execution for Saudi Arabia\'s most ambitious construction projects, supporting Vision 2030.',
    ourProjects: 'Our Projects',
    learnMore: 'Learn More',

    // MissionVision
    aboutTag: 'About Us',
    missionVisionTitle: 'About Us',
    aboutCompanyTitle: 'Our Story',
    aboutCompanyDescription: 'Established in 2011, the company specializes in medium-sized contracting projects across Saudi Arabia. Leveraging the founders\' expertise in engineering design, we built robust quality systems for delivering residential and commercial complexes. Our approach is rooted in understanding each design concept and bringing it to life during execution, while continuously developing our teams, maintaining high quality standards, and adhering to project schedules.',
    missionTitle: 'Our Mission',
    missionDescription: 'To deliver exceptional professionalism, precision, and efficient execution for Saudi Arabia\'s most ambitious construction projects, supporting Vision 2030.',
    visionTitle: 'Our Vision',
    visionDescription: 'To be the leading general contracting company in Saudi Arabia, recognized for excellence, innovation, and commitment to quality in every project we undertake.',
    valuesTitle: 'Our Values',
    valueExcellence: 'Excellence',
    valueIntegrity: 'Integrity',
    valueInnovation: 'Innovation',
    valueCollaboration: 'Collaboration',
    valueQuality: 'Quality',

    // Achievements
    achievementsTitle: 'Our Achievements',
    achievementAreaTitle: 'Executed Areas',
    achievementProjectsTitle: 'Number of Projects',
    achievementProjectsDesc: '170+ projects from 2012-2026',
    achievementValueTitle: 'Value of Executed Projects',
    achievementValueDesc: '247+ million from 2017 to 2026',

    // Project Stats Banner
    statsExecutedAreas: 'Executed Areas',
    statsThousandSqm: 'Thousand Square Meters',
    statsNumberOfProjects: 'Number of Projects',
    statsProject: 'Project',
    statsProjectsYears: '2012-2026',
    statsValueOfProjects: 'Value of Executed Projects',
    statsMillionSAR: 'Million Saudi Riyals',
    statsValueYears: '2017-2026',

    // Projects
    projectsTag: 'Our Portfolio',
    projectsTitle: 'Projects & Insights',
    projectsSubtitle: 'Explore our diverse portfolio of completed and ongoing construction projects across Saudi Arabia.',
    projectViewDetails: 'View Details',
    projectReadMore: 'READ MORE',
    project1Title: 'Al-Nada Sharafat',
    project1Description: 'Al-Nada District - Riyadh',
    project1Details: 'Commercial and entertainment complex restaurants and cafes.',
    project1Feature1: 'Project area: 17,000 m²',
    project1Feature2: 'Project cost: 25 million',
    project1Feature3: 'Prime location in Al-Nada District',
    project1Feature4: 'Modern commercial and entertainment spaces',
    project1Feature5: 'Premium dining and leisure destination',
    projectAreaLabel: 'Project Area',
    projectCostLabel: 'Project Cost',
    projectGalleryTitle: 'Project Gallery',

    project2Title: 'Private Villa Project',
    project2Description: 'Residential',
    project2Details: 'A collection of exclusive private villa developments showcasing luxury living and modern architectural design.',
    project2Feature1: 'Project area: 120,000 m²',
    project2Feature2: 'Project cost: 90+ million',
    project2Feature3: 'Premium residential developments',
    project2Feature4: 'Luxury villa designs',
    project2Feature5: 'High-end finishes and amenities',

    project3Title: 'Starta Villa Project',
    project3Description: 'Residential complex in Al Narjis- Riyadh',
    project3Details: 'A modern residential complex project featuring contemporary design and luxurious living spaces in Al Narjis, Riyadh.',
    project3Feature1: 'Project area: 11,700+ m²',
    project3Feature2: 'Project cost: 13+ million',
    project3Feature3: 'Residential complex',
    project3Feature4: 'Contemporary design',
    project3Feature5: 'Premium amenities',

    project4Title: 'Al-Ahsa Construction Station',
    project4Description: 'Commercial',
    project4Details: 'A modern commercial construction station in Al-Ahsa, providing comprehensive building materials and services.',
    project4Feature1: 'Project area: 2,100+ m²',
    project4Feature2: 'Project cost: 3+ million',
    project4Feature3: 'Prime commercial location',
    project4Feature4: 'Modern showroom and facilities',
    project4Feature5: 'Comprehensive construction services',

    project5Title: 'Mishkah Association Project',
    project5Description: 'Governorate Educational Complex',
    project5Details: 'A major educational complex project for the Mishkah Association, designed to serve the governorate with modern facilities.',
    project5Feature1: 'Project area: 5,100+ m²',
    project5Feature2: 'Project cost: 16+ million',
    project5Feature3: 'Educational complex',
    project5Feature4: 'Modern classrooms and facilities',
    project5Feature5: 'Comprehensive educational services',

    project6Title: 'Al-Waqf Mosque Project',
    project6Description: 'Governorate Charitable Endowment',
    project6Details: 'A beautiful and spacious mosque project built as a charitable endowment for the governorate.',
    project6Feature1: 'Project area: 8,000 m²',
    project6Feature2: 'Project cost: 12+ million',
    project6Feature3: 'Charitable endowment project',
    project6Feature4: 'Modern Islamic architecture',
    project6Feature5: 'Spacious prayer halls and facilities',

    project7Title: 'Riwaq Al Madinah',
    project7Description: 'Commercial complex',
    project7Details: 'A vibrant commercial complex offering a variety of retail and business spaces in a prime location in Al Madinah.',
    project7Feature1: 'Project area: 2,600+ m²',
    project7Feature2: 'Project cost: 12+ million',
    project7Feature3: 'Commercial complex',
    project7Feature4: 'Prime location',
    project7Feature5: 'Modern commercial spaces',

    project8Title: 'Sports Club Project (gym)',
    project8Description: 'Commercial complex',
    project8Details: 'A modern commercial complex featuring a fully-equipped sports club and gym facilities.',
    project8Feature1: 'Project area: 2,000+ m²',
    project8Feature2: 'Project cost: 2.6+ million',
    project8Feature3: 'Commercial complex',
    project8Feature4: 'Sports club and gym',
    project8Feature5: 'Modern fitness facilities',

    project9Title: 'Sports track parking & umbrellas project - Riyadh',
    project9Description: 'Commercial',
    project9Details: 'A commercial project featuring a sports track, parking, and umbrellas in Riyadh.',
    project9Feature1: 'Project area: 12,500 m²',
    project9Feature2: 'Project cost: 4.2+ million',
    project9Feature3: 'Commercial complex',
    project9Feature4: 'Sports track',
    project9Feature5: 'Parking and umbrellas',

    project10Title: 'Al Sharqi Avenue Complex Finishing Project',
    project10Description: 'Projects Commercial complex',
    project10Details: 'A high-end commercial complex finishing project for Al Sharqi Avenue.',
    project10Feature1: 'Project area: 5,100+ m²',
    project10Feature2: 'Project cost: 5+ million',
    project10Feature3: 'Commercial complex finishing',
    project10Feature4: 'Modern architecture',
    project10Feature5: 'Premium facilities',

    project11Title: 'Al Awali Makkah',
    project11Description: 'Commercial Complex',
    project11Details: 'A prominent commercial complex located in Al Awali area in Makkah.',
    project11Feature1: 'Project area: 46,650 m²',
    project11Feature2: 'Project cost: 9+ million',
    project11Feature3: 'Commercial complex',
    project11Feature4: 'Prime location in Makkah',
    project11Feature5: 'Modern commercial spaces',

    project12Title: 'Specialized Medical Clinics Project',
    project12Description: 'Medical clinic',
    project12Details: 'A state-of-the-art medical clinic project providing specialized healthcare services.',
    project12Feature1: 'Project area: 2,000+ m²',
    project12Feature2: 'Project cost: 2.6+ million',
    project12Feature3: 'Medical clinics',
    project12Feature4: 'Specialized healthcare',
    project12Feature5: 'Modern medical facilities',

    project13Title: 'Sharafat Park Al Khobar Complex',
    project13Description: 'Commercial Entertainment Commercial complexProject',
    project13Details: 'A major commercial and entertainment complex project in Al Khobar.',
    project13Feature1: 'Project area: 550,000+ m²',
    project13Feature2: 'Project cost: 20+ million',
    project13Feature3: 'Commercial and entertainment complex',
    project13Feature4: 'Prime location in Al Khobar',
    project13Feature5: 'Premium recreational spaces',

    project14Title: 'Justice Training Center - Riyadh',
    project14Description: 'Development of a government administrative building',
    project14Details: 'A major development project for a government administrative building in Riyadh.',
    project14Feature1: 'Project area: 4,850+ m²',
    project14Feature2: 'Project cost: 5.79+ million',
    project14Feature3: 'Government administrative building',
    project14Feature4: 'Modern design',
    project14Feature5: 'Advanced training facilities',

    project15Title: 'Office Projects',
    project15Description: 'Administrative',
    project15Details: 'A comprehensive administrative office project designed for modern business operations.',
    project15Feature1: 'Project area: 22,000+ m²',
    project15Feature2: 'Project cost: 38+ million',
    project15Feature3: 'Administrative offices',
    project15Feature4: 'Modern workspace design',
    project15Feature5: 'Premium business facilities',

    project16Title: 'Princess Abeer Complex Project',
    project16Description: 'Commercial complex - Restaurants',
    project16Details: 'A vibrant commercial complex featuring a variety of premium restaurants.',
    project16Feature1: 'Project area: 2,200+ m²',
    project16Feature2: 'Project cost: 9+ million',
    project16Feature3: 'Commercial complex and restaurants',
    project16Feature4: 'Premium dining experiences',
    project16Feature5: 'Modern commercial spaces',

    project17Title: 'Renovation works of the Prophet’s Mosque(Elharm) housing',
    project17Description: 'Renovation',
    project17Details: 'Extensive renovation works for the housing facilities of the Prophet\'s Mosque.',
    project17Feature1: 'Project area: 2,600+ m²',
    project17Feature3: 'Renovation works',
    project17Feature4: 'Housing facilities improvement',
    project17Feature5: 'Historical preservation and modernization',

    // Timeline
    timelineTag: 'Our Journey',
    timelineTitle: 'Milestones',
    timelineSubtitle: 'Timeline of our milestones and major projects over the years.',
    timelineFoundingTitle: 'Founding of the Company',
    timelineFoundingDesc: '- Establishment of Advanced Elements General Contracting',
    timelineGrowthTitle: 'Early Growth & Expansion',
    timelineGrowthDesc1: '- Membership in the Saudi Contractors Authority',
    timelineGrowthDesc2: '- First project outside Riyadh',
    timelineGrowthDesc3: '- Reaching 50 employees',
    timelineManufacturingTitle: 'Manufacturing Capabilities',
    timelineManufacturingDesc1: '- Establishment of the Metal Workshop',
    timelineManufacturingDesc2: '- Construction of the company\'s worker housing',
    timelineManufacturingDesc3: '- Establishment of a workshop for manufacturing air conditioning installation accessories (Smart)',
    timelineAcquisitionTitle: 'Strategic Acquisition',
    timelineAcquisitionDesc1: '- Acquisition of Air Experts company',
    timelineAcquisitionDesc2: '- Reaching a total of 103 employees',
    timelineEngineeringTitle: 'Manufacturing & Engineering',
    timelineEngineeringDesc1: '- Establishment of the Aluminum Factory',
    timelineEngineeringDesc2: '- Establishment of the company\'s engineering office in Cairo',
    timelineCovidTitle: 'COVID-19 Response',
    timelineCovidDesc: '- Continuation of operations during the COVID-19 crisis without interruption and delivery of projects on time, with 21 projects completed during the crisis',
    timelinePartnershipsTitle: 'Growth & Partnerships',
    timelinePartnershipsDesc1: '- Relocation to the new headquarters',
    timelinePartnershipsDesc2: '- Approval of Air Experts as an authorized supplier for the company',
    timelinePartnershipsDesc3: '- Entering into a partnership with Arc hob Engineering Consultancy as a strategic engineering partner',
    timelineTechnicalTitle: 'Technical Excellence',
    timelineTechnicalDesc: '- Establishment of the company\'s dedicated technical engineering office',
    timelineAchievementsTitle: 'Major Achievements',
    timelineAchievementsDesc1: '- Obtaining a first-grade contractor classification',
    timelineAchievementsDesc2: '- Securing an industrial license for a land of 204,285 square meters',
    timelineAchievementsDesc3: '- Reaching a total of 155 employees',
    timelineDepartmentTitle: 'Department Expansion',
    timelineDepartmentDesc1: '- Establishment of the Quality Management Department within the company',
    timelineDepartmentDesc2: '- Creation of the Marketing and Sales Department',
    timelineFutureTitle: 'Future Vision',
    timelineFutureDesc: '- Achieving Local Content Certification',
    timelineQuote: 'Success keeps moving forward, driven by our clients\' trust and our unwavering quality.',
    timelineTagCorporate: 'Corporate',
    timelineTagGrowth: 'Growth',
    timelineTagExpansion: 'Expansion',
    timelineTagManufacturing: 'Manufacturing',
    timelineTagInfrastructure: 'Infrastructure',
    timelineTagAcquisition: 'Acquisition',
    timelineTagEngineering: 'Engineering',
    timelineTagCrisisManagement: 'Crisis Management',
    timelineTagProjectDelivery: 'Project Delivery',
    timelineTagPartnerships: 'Partnerships',
    timelineTagTechnical: 'Technical',
    timelineTagCertification: 'Certification',
    timelineTagIndustrial: 'Industrial',
    timelineTagQualityManagement: 'Quality Management',
    timelineTagMarketing: 'Marketing',
    timelineTagLocalContent: 'Local Content',

    // Services
    servicesTag: 'What We Offer',
    servicesTitle: 'Our Services',
    servicesSubtitle: 'Comprehensive construction solutions for all your building needs.',

    // Facts
    factsEmployees: 'Employees',
    factsProjects: 'Projects',
    factsClients: 'Clients',

    // Partners
    partnersTag: 'Trusted By',
    partnersTitle: 'Our Partners',

    // Service Items
    serviceSupervisionTitle: "Supervision Services",
    serviceSupervisionDesc: "Visits - Complete supervision during execution - Preparation of reports and other supervision services",

    service3DTitle: "3D Design",
    service3DDesc: "Interior design - Exterior design - 3D design - Full site visualization",

    serviceLicensingTitle: "Licensing Services",
    serviceLicensingDesc: "Building permit preparation - Permit application - Permit correction - Plan submission - Permit tracking and other licensing services",

    serviceEngineeringTitle: "Engineering Design Services",
    serviceEngineeringDesc: "Survey work - Architectural design - Structural designs - Electrical designs - Mechanical designs - Safety system designs - Security and safety designs",

    serviceRealEstateTitle: "Real Estate Units",
    serviceRealEstateDesc: "Starting from the design phase to turnkey delivery, we provide comprehensive planning, design, and construction services for residential properties",

    serviceProjectSupervisionTitle: "Project Supervision",
    serviceProjectSupervisionDesc: "From the beginning of project launch, our supervision services ensure project execution according to plans and specifications",

    serviceProjectManagementTitle: "Project Management",
    serviceProjectManagementDesc: "We provide comprehensive project management services in accordance with international standards and PMI methodology",

    serviceDesignTitle: "Design & Development",
    serviceDesignDesc: "We provide various types of designs including architectural designs, interior designs, and exterior facades",

    serviceInteriorTitle: "Interior Design",
    serviceInteriorDesc: "We create interior designs that reflect your personal style and meet functional requirements",

    serviceUrbanPlanningTitle: "Urban Planning",
    serviceUrbanPlanningDesc: "Specialized planning that considers all aspects of the region's features and infrastructure requirements",

    serviceEnvironmentTitle: "Urban Planning & Environment",
    serviceEnvironmentDesc: "Strategic, integrated, and sustainable services that balance development needs with environmental preservation",

    serviceInteriorStylesTitle: "Interior Design Styles",
    serviceInteriorStylesDesc: "We help transform your style preferences into functional and beautiful interior spaces",

    serviceGeneralConstructionTitle: "General Construction",
    serviceGeneralConstructionBullets: [
      "Residential Buildings and Housing Complexes",
      "Government Buildings, Hospitals, and Commercial Complexes",
      "Government Buildings and Ministries",
      "Prefabricated Building Construction",
      "Industrial and Metal Structure Construction"
    ],

    serviceFinishingWorksTitle: "Finishing Works and Decorations",
    serviceFinishingWorksBullets: [
      "Interior and Exterior Finishing Works, and Turnkey project with professional Engineering Supervision"
    ],

    serviceMaintenanceTitle: "Building Maintenance and Operation Services",
    serviceMaintenanceBullets: [
      "Providing Innovative and Comprehensive Solutions for Maintenance and Operation Services Utilizing the latest programs for maintenance management, delivered by highly skilled technical teams."
    ],

    serviceRestorationTitle: "Restoration Works",
    serviceRestorationBullets: [
      "Providing Comprehensive Residential Building Restoration, Rehabilitation, and Development Services Tailored to Client Needs and Requirements"
    ],

    serviceSupervisionManagementTitle: "Engineering Supervision and Project Management Services",
    serviceSupervisionManagementBullets: [
      "Project Management and Construction Works We focus on comprehensive planning from the start, ensuring meticulous follow-up through all execution phases according to scheduled timelines"
    ],

    serviceElectromechanicalTitle: "Electromechanical Works",
    serviceElectromechanicalBullets: [
      "Execution of All Electrical and Mechanical Works Civil Defense Works"
    ],

    // WhyUs
    whyUsTag: 'Why Choose Us',
    whyUsTitle: 'Why',
    whyUsQuestionMark: '?',
    whyUsSubtitle: "We got you covered!",

    // WhyUs Cards
    whyUsCard1Title: 'Leaders in Construction and Contracting',
    whyUsCard1Description: 'Our ability to deliver large-scale projects with unmatched quality has established us as a key player in the Kingdom\'s contracting industry.',

    whyUsCard2Title: 'Quality and Customer Focus',
    whyUsCard2Description: 'At Advanced Elements Contracting, quality and customer satisfaction are our foundation and driving force.',

    whyUsCard3Title: '14 Years of Expertise',
    whyUsCard3Description: 'Since 2011, we\'ve built 14 years of experience, overcoming challenges and turning them into opportunities, making resilience a core part of our identity.',

    whyUsCard4Title: 'Innovative Solutions',
    whyUsCard4Description: 'Our R&D team pushes boundaries, delivering creative and technical solutions that exceed expectations and redefine possibilities.',

    whyUsCard5Title: 'Investing in People',
    whyUsCard5Description: 'We prioritize human capital, selecting top talent and fostering skills like positivity and continuous learning to drive success.',

    // Contact
    contactTag: 'Get In Touch',
    contactTitle: 'Get a Quote',
    contactSubtitle: 'Interested in working with us? Fill out the form below to receive a personalized quote for your project.',
    thankYou: 'Thank You!',
    contactSuccessMessage: 'We have received your message and will get back to you as soon as possible.',
    nameLabel: 'Name *',
    emailLabel: 'Email *',
    phoneLabel: 'Phone Number',
    messageLabel: 'Message *',
    sendMessage: 'Send Message',
    namePlaceholder: 'Your name',
    emailPlaceholder: 'Your email address',
    phonePlaceholder: 'Your phone number',
    messagePlaceholder: 'Your message',
    sending: 'Sending...',
    attachFilesLabel: 'Attachments (optional)',
    attachFilesHint: 'Images, PDF, DOCX — max 20 MB per file',
    attachFilesButton: 'Choose Files',
    removeFile: 'Remove',
    fileTooLarge: 'exceeds the 20 MB limit and was not added.',
    fileInvalidType: 'is not a supported file type.',

    // Project Details
    backToProjects: 'Back to Projects',
    projectOverview: 'Project Overview',
    keyFeatures: 'Key Features',
    contactUs: 'Contact Us',

    // Footer
    footerRights: 'All Rights Reserved',
    footerAddress: 'KSA, Riyadh 13317, Al Nada district\nNational Address: RADA7101',
    footerPhone: '966599028000',
    footerEmail: 'info@aeco.com.sa',
    footerLinks: 'Quick Links',
    footerPrivacy: 'Privacy Policy',
    footerTerms: 'Terms of Service',
    footerCareers: 'Careers',
    socials: 'Socials'
  },
  ar: {
    // TopFold
    aboutUs: 'من نحن',
    services: 'خدماتنا',
    projects: 'مشاريعنا',
    contact: 'اتصل بنا',
    getStarted: 'ابدأ الآن',
    generalContracting: 'المقاولات العامة',
    buildingTheFuture: 'نبني المستقبل',
    companyDescription: 'تقدم شركة العناصر المتقدمة للمقاولات العامة احترافية استثنائية ودقة وتنفيذ فعال لأكثر مشاريع البناء طموحاً في المملكة العربية السعودية، دعماً لرؤية المملكة ٢٠٣٠.',
    ourProjects: 'مشاريعنا',
    learnMore: 'اعرف المزيد',

    // MissionVision
    aboutTag: 'من نحن',
    missionVisionTitle: 'من نحن',
    aboutCompanyTitle: 'قصتنا',
    aboutCompanyDescription: 'تأسست الشركة عام 2011 وتتخصص في تنفيذ مشاريع المقاولات المتوسطة في المملكة العربية السعودية. بفضل خبرة المؤسسين في التصميم الهندسي، أنشأنا أنظمة جودة متينة لتنفيذ المجمعات السكنية والتجارية. يرتكز نهجنا على فهم فكرة التصميم وإبرازها أثناء التنفيذ، مع التطوير المستمر لفرق العمل والحفاظ على معايير الجودة العالية والالتزام بالجداول الزمنية للمشاريع.',
    missionTitle: 'رسالتنا',
    missionDescription: 'تقديم احترافية استثنائية ودقة وتنفيذ فعال لأكثر مشاريع البناء طموحاً في المملكة العربية السعودية، دعماً لرؤية المملكة ٢٠٣٠.',
    visionTitle: 'رؤيتنا',
    visionDescription: 'أن نكون الشركة الرائدة في مجال المقاولات العامة في المملكة العربية السعودية، معروفين بالتميز والابتكار والالتزام بالجودة في كل مشروع نقوم به.',
    valuesTitle: 'قيمنا',
    valueExcellence: 'التميز',
    valueIntegrity: 'النزاهة',
    valueInnovation: 'الابتكار',
    valueCollaboration: 'التعاون',
    valueQuality: 'الجودة',

    // Achievements (Arabic)
    achievementsTitle: 'إنجازاتنا',
    achievementAreaTitle: 'المساحات المنفذة',
    achievementProjectsTitle: 'عدد المشاريع',
    achievementProjectsDesc: 'أكثر من ١٧٠ مشروع من ٢٠١٢ إلى ٢٠٢٦',
    achievementValueTitle: 'قيمة المشاريع المنفذة',
    achievementValueDesc: 'أكثر من ٢٤٧ مليون من ٢٠١٧ إلى ٢٠٢٦',

    // Project Stats Banner
    statsExecutedAreas: 'المساحات المنفذة',
    statsThousandSqm: 'ألف متر مربع',
    statsNumberOfProjects: 'عدد المشاريع',
    statsProject: 'مشروع',
    statsProjectsYears: '2012-2026',
    statsValueOfProjects: 'قيمة المشاريع المنفذة',
    statsMillionSAR: 'مليون ريال سعودي',
    statsValueYears: '2017-2026',

    // Projects
    projectsTag: 'محفظة أعمالنا',
    projectsTitle: 'مشاريع ورؤى',
    projectsSubtitle: 'استكشف محفظتنا المتنوعة من مشاريع البناء المكتملة والجارية في جميع أنحاء المملكة العربية السعودية.',
    projectViewDetails: 'عرض التفاصيل',
    projectReadMore: 'اقرأ المزيد',
    project1Title: 'شرفات الندى',
    project1Description: 'حي النهد - الرياض',
    project1Details: 'مجمع تجاري وترفيهي يضم مطاعم ومقاهي.',
    project1Feature1: 'مساحة المشروع: ١٧,٠٠٠+ م²',
    project1Feature2: 'تكلفة المشروع: ٢٥ مليون',
    project1Feature3: 'موقع مميز في حي النهد',
    project1Feature4: 'مساحات تجارية وترفيهية عصرية',
    project1Feature5: 'وجهة راقية لتناول الطعام وقضاء أوقات الفراغ',
    projectAreaLabel: 'مساحة المشروع',
    projectCostLabel: 'تكلفة المشروع',
    projectGalleryTitle: 'معرض المشروع',

    project2Title: 'مشروع فلل خاصة',
    project2Description: 'سكني',
    project2Details: 'مجموعة من مشاريع الفيلات الفاخرة التي تعرض تصاميم معمارية عصرية ورفاهية في المعيشة.',
    project2Feature1: 'مساحة المشروع: ١٢٠,٠٠٠ م²',
    project2Feature2: 'تكلفة المشروع: ٩٠+ مليون',
    project2Feature3: 'تطويرات سكنية فاخرة',
    project2Feature4: 'تصاميم فيلات راقية',
    project2Feature5: 'تشطيبات ومرافق فاخرة',

    project3Title: 'مشروع فلل ستارتا',
    project3Description: 'مجمع سكني في حي النرجس - الرياض',
    project3Details: 'مشروع مجمع سكني حديث يتميز بتصميم معاصر ومساحات معيشة فاخرة في حي النرجس بالرياض.',
    project3Feature1: 'مساحة المشروع: ١١,٧٠٠+ م²',
    project3Feature2: 'تكلفة المشروع: ١٣+ مليون',
    project3Feature3: 'مجمع سكني',
    project3Feature4: 'تصميم معاصر',
    project3Feature5: 'مرافق راقية',

    project4Title: 'محطة البناء - الأحساء',
    project4Description: 'تجاري',
    project4Details: 'محطة بناء تجارية حديثة في الأحساء، توفر مواد بناء وخدمات شاملة.',
    project4Feature1: 'مساحة المشروع: ٢,١٠٠+ م²',
    project4Feature2: 'تكلفة المشروع: ٣+ مليون',
    project4Feature3: 'موقع تجاري متميز',
    project4Feature4: 'صالة عرض ومرافق حديثة',
    project4Feature5: 'خدمات بناء شاملة',

    project5Title: 'مشروع جمعية مشكاة',
    project5Description: 'مجمع تعليمي للمحافظة',
    project5Details: 'مشروع مجمع تعليمي كبير لجمعية مشكاة، مصمم لخدمة المحافظة بمرافق حديثة.',
    project5Feature1: 'مساحة المشروع: ٥,١٠٠+ م²',
    project5Feature2: 'تكلفة المشروع: ١٦+ مليون',
    project5Feature3: 'مجمع تعليمي',
    project5Feature4: 'فصول دراسية ومرافق حديثة',
    project5Feature5: 'خدمات تعليمية شاملة',

    project6Title: 'مشروع مسجد الوقف',
    project6Description: 'وقف خيري للمحافظة',
    project6Details: 'مشروع مسجد جميل وواسع تم بناؤه كوقف خيري للمحافظة.',
    project6Feature1: 'مساحة المشروع: ٨,٠٠٠ م²',
    project6Feature2: 'تكلفة المشروع: ١٢+ مليون',
    project6Feature3: 'مشروع وقف خيري',
    project6Feature4: 'عمارة إسلامية حديثة',
    project6Feature5: 'قاعات صلاة ومرافق واسعة',

    project7Title: 'رواق المدينة',
    project7Description: 'مجمع تجاري',
    project7Details: 'مجمع تجاري حيوي يقدم مجموعة متنوعة من مساحات التجزئة والأعمال في موقع متميز في المدينة المنورة.',
    project7Feature1: 'مساحة المشروع: ٢,٦٠٠+ م²',
    project7Feature2: 'تكلفة المشروع: ١٢+ مليون',
    project7Feature3: 'مجمع تجاري',
    project7Feature4: 'موقع متميز',
    project7Feature5: 'مساحات تجارية حديثة',

    project8Title: 'مشروع نادي رياضي',
    project8Description: 'مجمع تجاري',
    project8Details: 'مجمع تجاري حديث يضم نادي رياضي وصالة ألعاب رياضية مجهزة بالكامل.',
    project8Feature1: 'مساحة المشروع: ٢,٠٠٠+ م²',
    project8Feature2: 'تكلفة المشروع: ٢.٦+ مليون',
    project8Feature3: 'مجمع تجاري',
    project8Feature4: 'نادي رياضي',
    project8Feature5: 'مرافق لياقة بدنية حديثة',

    project9Title: 'مشروع مسار رياضي ومواقف ومظلات - الرياض',
    project9Description: 'تجاري',
    project9Details: 'مشروع تجاري لمسار رياضي ومواقف ومظلات في الرياض.',
    project9Feature1: 'مساحة المشروع: ١٢,٥٠٠ م²',
    project9Feature2: 'تكلفة المشروع: ٤.٢+ مليون',
    project9Feature3: 'مجمع تجاري',
    project9Feature4: 'مسار رياضي',
    project9Feature5: 'مواقف ومظلات',

    project10Title: 'مشروع تشطيب مجمع أفينيو الشرقي',
    project10Description: 'مشاريع مجمع تجاري',
    project10Details: 'مشروع تشطيب مجمع تجاري راقٍ لأفينيو الشرقي.',
    project10Feature1: 'مساحة المشروع: ٥,١٠٠+ م²',
    project10Feature2: 'تكلفة المشروع: ٥+ مليون',
    project10Feature3: 'تشطيب مجمع تجاري',
    project10Feature4: 'هندسة معمارية حديثة',
    project10Feature5: 'مرافق مميزة',

    project11Title: 'مجمع العوالي بمكة',
    project11Description: 'مجمع تجاري',
    project11Details: 'مجمع تجاري بارز يقع في منطقة العوالي بمكة المكرمة.',
    project11Feature1: 'مساحة المشروع: ٤٦,٦٥٠ م²',
    project11Feature2: 'تكلفة المشروع: ٩+ مليون',
    project11Feature3: 'مجمع تجاري',
    project11Feature4: 'موقع مميز في مكة',
    project11Feature5: 'مساحات تجارية حديثة',

    project12Title: 'مشروع عيادات طبية متخصصة',
    project12Description: 'عيادة طبية',
    project12Details: 'مشروع عيادة طبية حديثة تقدم خدمات رعاية صحية متخصصة.',
    project12Feature1: 'مساحة المشروع: ٢,٠٠٠+ م²',
    project12Feature2: 'تكلفة المشروع: ٢.٦+ مليون',
    project12Feature3: 'عيادات طبية',
    project12Feature4: 'رعاية صحية متخصصة',
    project12Feature5: 'مرافق طبية حديثة',

    project13Title: 'مجمع شرفات بارك الخبر',
    project13Description: 'مشروع مجمع تجاري ترفيهي',
    project13Details: 'مشروع مجمع تجاري وترفيهي ضخم في الخبر.',
    project13Feature1: 'مساحة المشروع: ٥٥٠,٠٠٠+ م²',
    project13Feature2: 'تكلفة المشروع: ٢٠+ مليون',
    project13Feature3: 'مجمع تجاري وترفيهي',
    project13Feature4: 'موقع مميز في الخبر',
    project13Feature5: 'مساحات ترفيهية راقية',

    project14Title: 'مركز التدريب العدلي - الرياض',
    project14Description: 'تطوير مبنى إداري حكومي',
    project14Details: 'مشروع تطوير مبنى إداري حكومي رئيسي في الرياض.',
    project14Feature1: 'مساحة المشروع: ٤,٨٥٠+ م²',
    project14Feature2: 'تكلفة المشروع: ٥.٧٩+ مليون',
    project14Feature3: 'مبنى إداري حكومي',
    project14Feature4: 'تصميم حديث',
    project14Feature5: 'مرافق تدريب متطورة',

    project15Title: 'مشاريع مكتبية',
    project15Description: 'إداري',
    project15Details: 'مشروع مكاتب إدارية شامل مصمم لعمليات الأعمال الحديثة.',
    project15Feature1: 'مساحة المشروع: ٢٢,٠٠٠+ م²',
    project15Feature2: 'تكلفة المشروع: ٣٨+ مليون',
    project15Feature3: 'مكاتب إدارية',
    project15Feature4: 'تصميم مساحة عمل حديثة',
    project15Feature5: 'مرافق أعمال راقية',

    project16Title: 'مشروع مجمع الأميرة عبير',
    project16Description: 'مجمع تجاري - مطاعم',
    project16Details: 'مجمع تجاري حيوي يضم مجموعة متنوعة من المطاعم الراقية.',
    project16Feature1: 'مساحة المشروع: ٢,٢٠٠+ م²',
    project16Feature2: 'تكلفة المشروع: ٩+ مليون',
    project16Feature3: 'مجمع تجاري ومطاعم',
    project16Feature4: 'تجارب طعام استثنائية',
    project16Feature5: 'مساحات تجارية حديثة',

    project17Title: 'أعمال ترميم سكن المسجد النبوي (الحرم)',
    project17Description: 'ترميم',
    project17Details: 'أعمال ترميم واسعة النطاق لمرافق سكن المسجد النبوي.',
    project17Feature1: 'مساحة المشروع: ٢,٦٠٠+ م²',
    project17Feature3: 'أعمال ترميم',
    project17Feature4: 'تحسين مرافق السكن',
    project17Feature5: 'الحفاظ على التراث والتحديث',

    // Timeline
    timelineTag: 'رحلتنا',
    timelineTitle: 'الإنجازات',
    timelineSubtitle: 'الجدول الزمني لإنجازاتنا ومشاريعنا الرئيسية على مر السنين.',
    timelineFoundingTitle: 'تأسيس الشركة',
    timelineFoundingDesc: '- تأسيس شركة العناصر المتقدمة للمقاولات العامة',
    timelineGrowthTitle: 'النمو المبكر والتوسع',
    timelineGrowthDesc1: '- العضوية في هيئة المقاولين السعوديين',
    timelineGrowthDesc2: '- أول مشروع خارج الرياض',
    timelineGrowthDesc3: '- الوصول إلى ٥٠ موظفًا',
    timelineManufacturingTitle: 'قدرات التصنيع',
    timelineManufacturingDesc1: '- إنشاء ورشة المعادن',
    timelineManufacturingDesc2: '- بناء سكن عمال الشركة',
    timelineManufacturingDesc3: '- إنشاء ورشة لتصنيع ملحقات تركيب أجهزة التكييف (سمارت)',
    timelineAcquisitionTitle: 'الاستحواذ الاستراتيجي',
    timelineAcquisitionDesc1: '- الاستحواذ على شركة خبراء الهواء',
    timelineAcquisitionDesc2: '- الوصول إلى إجمالي ١٠٣ موظفين',
    timelineEngineeringTitle: 'التصنيع والهندسة',
    timelineEngineeringDesc1: '- إنشاء مصنع الألمنيوم',
    timelineEngineeringDesc2: '- إنشاء مكتب الشركة الهندسي في القاهرة',
    timelineCovidTitle: 'الاستجابة لكوفيد-١٩',
    timelineCovidDesc: '- استمرار العمليات خلال أزمة كوفيد-١٩ دون انقطاع وتسليم المشاريع في الوقت المحدد، مع إنجاز ٢١ مشروعًا خلال الأزمة',
    timelinePartnershipsTitle: 'النمو والشراكات',
    timelinePartnershipsDesc1: '- الانتقال إلى المقر الرئيسي الجديد',
    timelinePartnershipsDesc2: '- اعتماد خبراء الهواء كمورد معتمد للشركة',
    timelinePartnershipsDesc3: '- الدخول في شراكة مع شركة آرك هوب للاستشارات الهندسية كشريك هندسي استراتيجي',
    timelineTechnicalTitle: 'التميز التقني',
    timelineTechnicalDesc: '- إنشاء مكتب الشركة الهندسي التقني المتخصص',
    timelineAchievementsTitle: 'الإنجازات الرئيسية',
    timelineAchievementsDesc1: '- الحصول على تصنيف مقاول من الدرجة الأولى',
    timelineAchievementsDesc2: '- تأمين ترخيص صناعي لأرض مساحتها ٢٠٤,٢٨٥ متر مربع',
    timelineAchievementsDesc3: '- الوصول إلى إجمالي ١٥٥ موظفًا',
    timelineDepartmentTitle: 'توسيع الأقسام',
    timelineDepartmentDesc1: '- إنشاء قسم إدارة الجودة داخل الشركة',
    timelineDepartmentDesc2: '- إنشاء قسم التسويق والمبيعات',
    timelineFutureTitle: 'رؤية المستقبل',
    timelineFutureDesc: '- تحقيق شهادة المحتوى المحلي',
    timelineQuote: 'النجاح يستمر في التقدم، مدفوعًا بثقة عملائنا وجودتنا الثابتة.',
    timelineTagCorporate: 'الشركات',
    timelineTagGrowth: 'النمو',
    timelineTagExpansion: 'التوسع',
    timelineTagManufacturing: 'التصنيع',
    timelineTagInfrastructure: 'البنية التحتية',
    timelineTagAcquisition: 'الاستحواذ',
    timelineTagEngineering: 'الهندسة',
    timelineTagCrisisManagement: 'إدارة الأزمات',
    timelineTagProjectDelivery: 'تسليم المشروع',
    timelineTagPartnerships: 'الشراكات',
    timelineTagTechnical: 'التقنية',
    timelineTagCertification: 'الشهادات',
    timelineTagIndustrial: 'الصناعة',
    timelineTagQualityManagement: 'إدارة الجودة',
    timelineTagMarketing: 'التسويق',
    timelineTagLocalContent: 'المحتوى المحلي',

    // Services
    servicesTag: 'ما نقدمه',
    servicesTitle: 'خدماتنا',
    servicesSubtitle: 'حلول بناء شاملة لجميع احتياجات البناء الخاصة بك.',

    // Facts
    factsEmployees: 'موظف',
    factsProjects: 'مشروع',
    factsClients: 'عميل',

    // Partners
    partnersTag: 'موثوق من قبل',
    partnersTitle: 'شركاؤنا',

    // Service Items
    serviceSupervisionTitle: "خدمات الإشراف",
    serviceSupervisionDesc: "الزيارات - الإشراف الكامل أثناء التنفيذ - إعداد التقارير وخدمات الإشراف الأخرى",

    service3DTitle: "التصميم ثلاثي الأبعاد",
    service3DDesc: "التصميم الداخلي - التصميم الخارجي - التصميم ثلاثي الأبعاد - تصور كامل للموقع",

    serviceLicensingTitle: "خدمات الترخيص",
    serviceLicensingDesc: "إعداد تصريح البناء - تقديم التصريح - تصحيح التصريح - تقديم المخطط - تتبع التصريح وخدمات الترخيص الأخرى",

    serviceEngineeringTitle: "خدمات التصميم الهندسي",
    serviceEngineeringDesc: "أعمال المسح - التصميم المعماري - التصاميم الإنشائية - التصاميم الكهربائية - التصاميم الميكانيكية - تصاميم أنظمة السلامة - تصاميم الأمن والسلامة",

    serviceRealEstateTitle: "الوحدات العقارية",
    serviceRealEstateDesc: "بدءًا من مرحلة التصميم وحتى التسليم الجاهز، نقدم خدمات شاملة للتخطيط والتصميم والبناء للعقارات السكنية",

    serviceProjectSupervisionTitle: "الإشراف على المشاريع",
    serviceProjectSupervisionDesc: "من بداية إطلاق المشروع، تضمن خدمات الإشراف لدينا تنفيذ المشروع وفقًا للخطط والمواصفات",

    serviceProjectManagementTitle: "إدارة المشاريع",
    serviceProjectManagementDesc: "نقدم خدمات شاملة لإدارة المشاريع وفقًا للمعايير الدولية ومنهجية PMI",

    serviceDesignTitle: "التصميم والتطوير",
    serviceDesignDesc: "نقدم أنواعًا مختلفة من التصاميم بما في ذلك التصاميم المعمارية والتصاميم الداخلية والواجهات الخارجية",

    serviceInteriorTitle: "التصميم الداخلي",
    serviceInteriorDesc: "نقوم بإنشاء تصاميم داخلية تعكس أسلوبك الشخصي وتلبي المتطلبات الوظيفية",

    serviceUrbanPlanningTitle: "التخطيط الحضري",
    serviceUrbanPlanningDesc: "تخطيط متخصص يأخذ في الاعتبار جميع جوانب ميزات المنطقة ومتطلبات البنية التحتية",

    serviceEnvironmentTitle: "التخطيط الحضري والبيئة",
    serviceEnvironmentDesc: "خدمات استراتيجية ومتكاملة ومستدامة توازن بين احتياجات التنمية والحفاظ على البيئة",

    serviceInteriorStylesTitle: "أنماط التصميم الداخلي",
    serviceInteriorStylesDesc: "نساعد في تحويل تفضيلات أسلوبك إلى مساحات داخلية وظيفية وجميلة",

    serviceGeneralConstructionTitle: "المقاولات العامة",
    serviceGeneralConstructionBullets: [
      "المباني السكنية والمجمعات السكنية",
      "المباني الحكومية والمستشفيات والمجمعات التجارية",
      "المباني الحكومية والوزارات",
      "البناء الجاهز (المسبق الصنع)",
      "البناء الصناعي وبناء الهياكل المعدنية"
    ],

    serviceFinishingWorksTitle: "أعمال التشطيبات والديكورات",
    serviceFinishingWorksBullets: [
      "أعمال التشطيبات الداخلية والخارجية، ومشاريع تسليم مفتاح بإشراف هندسي محترف"
    ],

    serviceMaintenanceTitle: "خدمات صيانة وتشغيل المباني",
    serviceMaintenanceBullets: [
      "تقديم حلول مبتكرة وشاملة لصيانة وتشغيل المباني باستخدام أحدث برامج إدارة الصيانة، من خلال فرق فنية عالية الكفاءة."
    ],

    serviceRestorationTitle: "أعمال الترميم",
    serviceRestorationBullets: [
      "تقديم خدمات شاملة لترميم وإعادة تأهيل وتطوير المباني السكنية بما يتناسب مع احتياجات ومتطلبات العملاء"
    ],

    serviceSupervisionManagementTitle: "خدمات الإشراف الهندسي وإدارة المشاريع",
    serviceSupervisionManagementBullets: [
      "إدارة المشاريع وأعمال الإنشاء نركز على التخطيط الشامل من البداية، مع متابعة دقيقة لجميع مراحل التنفيذ وفق الجداول الزمنية المحددة"
    ],

    serviceElectromechanicalTitle: "الأعمال الكهروميكانيكية",
    serviceElectromechanicalBullets: [
      "تنفيذ جميع الأعمال الكهربائية والميكانيكية وأعمال الدفاع المدني"
    ],

    // WhyUs
    whyUsTag: 'لماذا تختارنا',
    whyUsTitle: 'لماذا',
    whyUsQuestionMark: '؟',
    whyUsSubtitle: 'خدماتنا',

    // WhyUs Cards
    whyUsCard1Title: 'رواد في البناء والمقاولات',
    whyUsCard1Description: 'قدرتنا على تنفيذ مشاريع كبيرة بجودة لا مثيل لها جعلتنا لاعبًا رئيسيًا في صناعة المقاولات في المملكة.',

    whyUsCard2Title: 'الجودة والتركيز على العميل',
    whyUsCard2Description: 'في شركة العناصر المتقدمة للمقاولات، تعتبر الجودة ورضا العملاء أساسنا وقوتنا الدافعة.',

    whyUsCard3Title: '١٤ عامًا من الخبرة',
    whyUsCard3Description: 'منذ عام ٢٠١١، بنينا ١٤ عامًا من الخبرة، وتغلبنا على التحديات وحولناها إلى فرص، مما جعل المرونة جزءًا أساسيًا من هويتنا.',

    whyUsCard4Title: 'حلول مبتكرة',
    whyUsCard4Description: 'يدفع فريق البحث والتطوير لدينا الحدود، ويقدم حلولًا إبداعية وتقنية تتجاوز التوقعات وتعيد تعريف الإمكانيات.',

    whyUsCard5Title: 'الاستثمار في الأفراد',
    whyUsCard5Description: 'نعطي الأولوية لرأس المال البشري، واختيار أفضل المواهب وتعزيز المهارات مثل الإيجابية والتعلم المستمر لدفع النجاح.',

    // Contact
    contactTag: 'تواصل معنا',
    contactTitle: 'احصل على عرض سعر',
    contactSubtitle: 'هل أنت مهتم بالعمل معنا؟ قم بتعبئة النموذج أدناه للحصول على عرض سعر مخصص لمشروعك.',
    thankYou: 'شكراً لك!',
    contactSuccessMessage: 'لقد استلمنا رسالتك وسنرد عليك في أقرب وقت ممكن.',
    nameLabel: 'الاسم *',
    emailLabel: 'البريد الإلكتروني *',
    phoneLabel: 'رقم الهاتف',
    messageLabel: 'الرسالة *',
    sendMessage: 'إرسال الرسالة',
    namePlaceholder: 'اسمك',
    emailPlaceholder: 'عنوان بريدك الإلكتروني',
    phonePlaceholder: 'رقم هاتفك',
    messagePlaceholder: 'رسالتك',
    sending: 'جاري الإرسال...',
    attachFilesLabel: 'المرفقات (اختياري)',
    attachFilesHint: 'صور، PDF، DOCX — الحد الأقصى 20 ميجابايت لكل ملف',
    attachFilesButton: 'اختيار الملفات',
    removeFile: 'إزالة',
    fileTooLarge: 'يتجاوز حد 20 ميجابايت ولم تتم إضافته.',
    fileInvalidType: 'نوع الملف غير مدعوم.',

    // تفاصيل المشروع
    backToProjects: 'العودة إلى المشاريع',
    projectOverview: 'نظرة عامة على المشروع',
    keyFeatures: 'الميزات الرئيسية',
    contactUs: 'اتصل بنا',

    // Footer
    footerRights: 'جميع الحقوق محفوظة',
    footerAddress: 'المملكة العربية السعودية - الرياض 13317 - حي الندى\nالعنوان الوطني: RADA7101',
    footerPhone: '966599028000',
    footerEmail: 'info@aeco.com.sa',
    footerLinks: 'روابط سريعة',
    footerPrivacy: 'سياسة الخصوصية',
    footerTerms: 'شروط الخدمة',
    footerCareers: 'وظائف',
    socials: 'وسائل التواصل'
  }
};

export default translations; 